import classNames from 'classnames';
import React from 'react';
import SearchResultsTabs from '../SearchResultTabs/SearchResultTabs';
import './sidebarLayout.less';

export interface Props {
  sidebar?: React.JSX.Element;
  showTabs?: boolean;
  children?: React.ReactNode;
}

const SidebarLayout: React.FC<Props> = (props) => {
  return (
    // eslint-disable-next-line no-extra-boolean-cast -- auto-generated TECH-258
    <div className={classNames('sidebar-layout', { 'sidebar-hidden': !Boolean(props.sidebar) })}>
      {/* eslint-disable-next-line no-extra-boolean-cast -- auto-generated TECH-258 */}
      <div className={classNames('sidebar-layout__sidebar', { hide: !Boolean(props.sidebar) })}>{props.sidebar}</div>
      <div className="sidebar-container">
        {(props.showTabs && <SearchResultsTabs />) || null}
        <div className="sidebar-layout__main-content">{props.children}</div>
      </div>
    </div>
  );
};

export default SidebarLayout;
